import L, { Util } from "leaflet";
import { WebCanvas } from "../features/CanvasMarker/WebCanvas";
import * as PIXI from "pixi.js";

L.Map.include({
	getWebGlRenderer: function (layer: any) {
		let renderer = layer.options.renderer || this._rendererWebGL;

		if (!renderer) {
			renderer = this._rendererWebGL = this._createWebGlRenderer();
		}

		if (!this.hasLayer(renderer)) {
			this.addLayer(renderer);
		}
		return renderer;
	},

	_createWebGlRenderer: function (options: any) {
		let renderer = new WebCanvas();
		return renderer;
	},
});

export const PixiMarker: any = L.CircleMarker.extend({
	initialize: function (latlng: any, options: any) {
		Util.setOptions(this, options);
		this._latlng = L.latLng(latlng);
		this._radius = this.options.radius;
	},

	beforeAdd: function (map: any) {
		this._renderer = map.getWebGlRenderer(this);
	},
	onAdd: function (map: any) {
		L.CircleMarker.prototype.onAdd.call(this, map);
		this.on("pointerup", this.openPopup);
	},

	onRemove: function (map: any) {
		L.CircleMarker.prototype.onRemove.call(this, map);
		this.off("pointerup", this.openPopup);
	},
	_updatePath: function () {
		let app: PIXI.Application = this._renderer._app;
		let sprite: PIXI.Sprite = this.sprite;
		let point: L.Point = this._point;
		if (!app.stage.children.includes(sprite)) return;
		sprite.x = point.x;
		sprite.y = point.y;
	},
	getOpacity: function () {
		return this._opacity;
	},
	setOpacity: function (opacity: any) {
		this._opacity = opacity;
		this.sprite.alpha = opacity;
	},
	handleClick: function (layer: any) {
		const { eventHandlers } = layer.options;
		if (eventHandlers?.click) {
			eventHandlers.click();
		}
	},
});
